import React from "react";
import { HoverCard } from "./ResultsPrimitives.jsx";

export default function ReportsDisabledActionHoverCard({
  actionLabel = "",
  disabledReason = "",
  children,
  fitContent = false,
}) {
  const action = !disabledReason ? children : (
    <HoverCard
      accentColor="var(--hovercard-accent-warning)"
      content={(
        <div className="grid gap-1">
          {actionLabel ? <p className="font-semibold text-slate-950">{actionLabel}</p> : null}
          <p>{disabledReason}</p>
        </div>
      )}
      placement="top"
      title="Action désactivée"
      openOnTouch
      flat
    >
      {children}
    </HoverCard>
  );

  return <div className={fitContent ? "grid w-max min-w-0" : "grid w-full min-w-0"}>{action}</div>;
}
